import React  from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';


import { options } from './chart';
import moment from 'moment';



const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


const newOptions = {
  scales: {
    y: {
      ticks: {
        beginAtZero: true,
      },
    },
  },
}

const SaleHours = props => {
  const { className, weekReports = [], title = 'Weekly Sales Overview', total, currencySymbol, ...rest} = props;

  const classes = useStyles();
  
  // Check if weekReports is valid and has data
  if (!weekReports || !Array.isArray(weekReports)) {
    return (
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardHeader
          title={title}
        />
        <Divider />
        <CardContent>
          <div className={classes.chartContainer}>
            <div>No data available</div>
          </div>
        </CardContent>
        <Divider />
      </Card>
    );
  }

  // current date format is dd/mm/yyyy, need to convert to mm/dd/ with week day
  const labelList = weekReports.map(item => moment(item.date, 'DD/MM/YYYY').format('DD/MM ddd'));
  const data = {
    datasets: [
      {
        backgroundColor: '#8884d8',
        data: weekReports.map((item) => Number(item.total.toFixed(2))),
        label: 'Total',
        maxBarThickness: 20,
        minBarLength: 2,
      }
    ],
    labels: labelList,
  };
 
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        // action={
        //   <Button
        //     size="small"
        //     variant="text"
        //   >
        //     Last 7 days <ArrowDropDownIcon />
        //   </Button>
        // }
        title={title}
        subheader={total ? `Total: ${total}` : undefined}
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          {data && data.labels && data.datasets ? (
            <Bar
              key={`bar-chart-${JSON.stringify(data.labels)}`}
              data={data}
              options={options}
            />
          ) : (
            <div>Loading chart...</div>
          )}
        </div>
      </CardContent>
      <Divider />
      {/* <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          Overview <ArrowRightIcon />
        </Button>
      </CardActions> */}
    </Card>
  );
};

SaleHours.propTypes = {
  className: PropTypes.string,
  weekReports: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired
  })),
  title: PropTypes.string,
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SaleHours;
